import { Button, message, Switch } from 'antd'
import TextArea from 'antd/lib/input/TextArea'
import api, { MetadataAttribute, MetadataView, MetadataViewIn } from 'api'
import { AppGridHeard } from 'components/AppGridLayout/AppGridHeard'
import AppGridLayout from 'components/AppGridLayout/AppGridLayout'
import AppGridTab from 'components/AppGridLayout/AppGridTab'
import AppGridTabs from 'components/AppGridLayout/AppGridTabs'
import AppGridView from 'components/AppGridLayout/AppGridView'
import { AppTable } from 'components/AppTable'
import React, { useState } from 'react'

interface Props {
	systemCode?: string
	displayName?: string
	name?: string
	text?: string
	viewAttr?: MetadataAttribute[]
	metadataView?: MetadataView
}

export const ViewTable = (props: Props) => {
	const [tableSearch, setTableSearch] = useState({
		systemCode: props.systemCode,
		name: '',
	})
	const [text, setText] = useState(props.text || '')
	const [viewAttr, setViewAttr] = useState(props.viewAttr)
	const [flag, setFlag] = useState(false)
	const [metadataView, setMetadataView] = useState(props.metadataView || [])
	const refTable = React.createRef<AppTable>()
	const textArea = React.createRef<TextArea>()
	const onChange = async (data: MetadataAttribute) => {
		let attr = viewAttr as MetadataAttribute[]
		let newAttr = [] as MetadataAttribute[]
		attr.forEach(e => {
			e.isPrimaryAttribute = false
			newAttr.push(e)
		})
		if (!data.isPrimaryAttribute) {
			newAttr.map(e => {
				if (e.id === data.id) {
					e.isPrimaryAttribute = true
				}
			})
		}
		setViewAttr(newAttr)
		refTable && refTable.current && refTable.current.fetchDataSource(newAttr)
		let result = await api.modeling.entity.updateView(
			Object.assign(metadataView, { metadataAttributeList: newAttr })
		)
		if (result) {
			message.success('修改成功!')
		} else {
			message.warn('无法保存，请联系管理员')
		}
	}
	const getTextArea = (e: any) => {
		setText(e.target.value)
	}
	const saveView = async () => {
		let obj = {
			systemCode: props.systemCode,
			sqlText: text,
			name: props.name,
			displayName: props.displayName,
		} as MetadataViewIn
		let attr = await api.modeling.entity.getAttrBySql(obj)
		let result =
			props.metadataView || flag
				? await api.modeling.entity.updateView(
						Object.assign(metadataView, { sqlText: text, metadataAttributeList: attr })
				  )
				: await api.modeling.entity.createView(obj)
		if (result) {
			message.success('修改成功!')
			setMetadataView(result)
			setFlag(true)
		} else {
			message.warn('无法保存，请联系管理员')
		}
		setViewAttr(attr)
	}
	const edieAttr = async () => {
		let attr = refTable.current.getGridData() as MetadataAttribute[]
		let result = await api.modeling.entity.updateView(Object.assign(metadataView, { metadataAttributeList: attr }))
		if (result) {
			message.success('修改成功!')
		} else {
			message.warn('无法保存，请联系管理员')
		}
	}
	return (
		<AppGridLayout defaultViewId={1}>
			<AppGridHeard>
				<AppGridTabs>
					<AppGridTab title="查询脚本" viewId={1}></AppGridTab>
					<AppGridTab title="字段信息" viewId={2}></AppGridTab>
				</AppGridTabs>
			</AppGridHeard>
			<AppGridView viewId={1}>
				<div>
					<TextArea
						autosize={{ minRows: 10, maxRows: 15 }}
						ref={textArea}
						defaultValue={text}
						onChange={getTextArea}
					/>
					<div style={{ display: 'flex', justifyContent: 'center' }}>
						<Button type="primary" htmlType="submit" onClick={saveView}>
							保存
						</Button>
					</div>
				</div>
			</AppGridView>
			<AppGridView viewId={2}>
				<Button type="primary" onClick={edieAttr}>
					修改
				</Button>
				<AppTable dataSource={viewAttr} ref={refTable} rowKey="id">
					<AppTable.ColIndex width={20} />
					<AppTable.ColEdit title="中文名" field="displayName" width={200} />
					<AppTable.Col title="英文名" field="name" width={200} />
					<AppTable.Col
						title="主键"
						width={200}
						field="isPrimaryAttribute"
						render={(data: any) => {
							return <Switch checked={data.isPrimaryAttribute} onChange={() => onChange(data)} />
						}}
					/>
				</AppTable>
			</AppGridView>
		</AppGridLayout>
	)
}



// WEBPACK FOOTER //
// ./src/modules/modeling/entity/components/ViewTable.tsx